import React from 'react';
const FloatButtonGroupContext = /*#__PURE__*/React.createContext(undefined);
export const {
  Provider: FloatButtonGroupProvider
} = FloatButtonGroupContext;
export default FloatButtonGroupContext;